var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M20.821 2.375h-5.089l-.399-.804A1.016 1.016 0 0014.422 1H9.574a1.004 1.004 0 00-.907.571l-.4.804H3.18a.684.684 0 00-.679.688v1.375c0 .38.304.687.679.687h17.64a.683.683 0 00.679-.687V3.063a.684.684 0 00-.679-.688zM4.756 21.066A2.048 2.048 0 006.788 23h10.424a2.048 2.048 0 002.032-1.934L20.143 6.5H3.857l.9 14.566z"
  }))));
}

export default SvgTrash;